import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import 'styles/sports/sal.scss';


const CourseInfo = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()


    const courseSportCode = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'COURSE_SAILED')?.ei_value;
    const course = <SportCode discipline={mirs_discipline} entity='@Course' code={courseSportCode} />

    const airTemperature = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'AIR_TEMP')?.ei_value;
    const humidity = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'HUMIDITY')?.ei_value;
    const seaState = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'SEA_STATE')?.ei_value;

    return (
        <div className="courseinfo-bk">
            <div><span className="fw-bold"><Label data={'HeaderCourse'} />:</span> {course}</div>
            <div><span className="fw-bold"><Label data={'HeaderAirTemperature'} />:</span> {airTemperature}</div>
            <div><span className="fw-bold"><Label data={'HeaderHumidity'} />:</span> {humidity}</div>
            <div><span className="fw-bold"><Label data={'HeaderSeaState'} />:</span> {seaState}</div>
        </div>
    );
}

export default CourseInfo;